import { Button, colors } from '@insurancemenu/imenu-components-lib';
import styled, { css, CSSProp } from 'styled-components';

interface ExpandButtonStyledProps {
  collapsed: boolean;
}

export const GuidelineCardStyled = styled.div`
  background-color: ${colors.neutral.white};
  border-radius: 10px;
  padding: 2.4rem 4rem;
  margin-bottom: 4rem;
`;

export const ExpandButtonStyled = styled(Button)<ExpandButtonStyledProps>`
  font-size: 1.6rem;
  line-height: 2.4rem;
  font-weight: 500;
  color: ${colors.neutral[900]};
  letter-spacing: 0.05rem;
  text-align: center;
  border-bottom: 0.1rem solid #c1c7cd;
  text-transform: uppercase;
  width: 100%;
  border-radius: 0;
  padding-bottom: 1.6rem;

  ${({ collapsed }): CSSProp =>
    collapsed &&
    css`
      padding-bottom: 0;
      border-bottom: none;
    `}
`;

export const ProductLineWrapperStyled = styled.div`
  padding-top: 3.6rem;
`;

export const GuidelineRulesBlockStyled = styled.div`
  margin-top: 1.6rem;
`;

export const RuleNameStyled = styled.span`
  font-size: 1.6rem;
  line-height: 2.4rem;
  font-weight: 700;
  color: ${colors.neutral[900]};
  letter-spacing: 0.02rem;
`;

export const RuleTextStyled = styled.span`
  font-size: 1.6rem;
  line-height: 2.4rem;
  font-weight: 400;
  color: ${colors.neutral[900]};
  letter-spacing: 0.02rem;
`;
